import useController from "./controller";
import { useTranslation } from "../../locales";
import { NavigationMenuItemInterface } from "../../types";

function useViewController() {
  const { t } = useTranslation();
  const { user, isPerformer } = useController();
  const itemsList: NavigationMenuItemInterface[] = [
    {
      title: t("Main info"),
      name: "settings",
      icon: "signup",
      to: "/user/settings",
    },
    ...(isPerformer
      ? [
          {
            title: t("Payment info"),
            name: "payment_info",
            icon: "wallet",
            to: "/user/payment-info",
          },
        ]
      : []),
    {
      title: t("Balance history"),
      name: "history",
      icon: "history",
      to: "/user/transactions",
    },
    {
      title: t("Appointments"),
      name: "appointments",
      icon: "available",
      to: "/user/appointments",
    },
    ...(isPerformer
      ? [
          {
            title: t("Calendar"),
            name: "calendar",
            icon: "calendar",
            to: "/user/calendar",
          },
        ]
      : []),
    {
      title: t("Change password"),
      name: "password",
      icon: "show-off",
      to: "/user/change-password",
    },
    {
      title: t("Log out"),
      name: "logout",
      icon: "logout",
      to: "/logout",
    },
  ];

  return {
    user,
    itemsList,
    isPerformer,
  };
}

export default useViewController;
